import { FormControl, FormGroup, Validators } from '@angular/forms';
import { combineLatest } from 'rxjs';
import { DeviceEnum, FrameIDTypeEnum, SearchItems, setRequired } from '../core';


const SPECIAL_CHARS_PATTERN: RegExp = /^[^<>%#&?,]+$/;
const SPECIAL_CHARS_TEXT = '<>%#&?,';
const SPECIAL_CHARS_LITE_PATTERN: RegExp = /^[^<>%#?]+$/;
const SPECIAL_CHARS_LITE_TEXT = '<>%#?';
const patientId_maxLength = 50;
const patientInitials_maxLength = 5;
const planId_maxLength = 50;
const planNotes_maxLength = 1000;

export const patientId_notUnique = 'patientIdNotUnique';
export const planId_notUnique = 'planIdNotUnique';
export const noFramesAvailable = 'noFramesAvailable';
export const unsupportedModel = 'unsupportedModel';


export class ReceivedCloneControl implements IReceivedCloneControl {
	existingPatient = new FormControl<SearchItems | null>(null, [Validators.required]);
	patientId = new FormControl<string | null>(null, [Validators.maxLength(patientId_maxLength), Validators.pattern(SPECIAL_CHARS_PATTERN)]);
	patientInitials = new FormControl<string | null>(null, [Validators.maxLength(patientInitials_maxLength), Validators.pattern(SPECIAL_CHARS_PATTERN)]);
	planGuid = new FormControl<string | null>(null, [Validators.required]);
	planId = new FormControl<string | null>(null, [Validators.required, Validators.maxLength(planId_maxLength), Validators.pattern(SPECIAL_CHARS_PATTERN)]);
	planNotes = new FormControl<string | null>(null, [Validators.maxLength(planNotes_maxLength), Validators.pattern(SPECIAL_CHARS_LITE_PATTERN)]);
	frameId = new FormControl<FrameIDTypeEnum | null>(null);
	device = new FormControl<DeviceEnum | null>(null);
}

export function setReceivedCloneValidators(form: FormGroup<ReceivedCloneControl>): void {
	combineLatest([form.controls.existingPatient.valueChanges, form.controls.patientId.valueChanges]).subscribe(([existingPat, patId]) => {
		setRequired(form.controls.existingPatient, !patId || patId === '');
		setRequired(form.controls.patientId, !existingPat);
		setRequired(form.controls.patientInitials, !existingPat);
	});
}

export const receivedCloneErrorMsgs: { [key in keyof ReceivedCloneForm]: { [y: string]: string[] } | null } = {
	existingPatient: {
		[`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_PATIENT']
	},
	patientId: {
		[`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_PATIENTID'],
		[`${Validators.maxLength.name.toLowerCase()}`]: ['VALIDATION_MESSAGE_MAXLENGTH_PATIENTID', patientId_maxLength.toString()],
		[`${Validators.pattern.name}`]: ['VALIDATION_MESSAGE_SPECIALCHARS_PATIENTID', SPECIAL_CHARS_TEXT],
		[`${patientId_notUnique}`]: ['VALIDATION_MESSAGE_UNIQUE_PATIENTID']
	},
	patientInitials: {
		[`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_PATIENT_INITIALS'],
		[`${Validators.maxLength.name.toLowerCase()}`]: ['VALIDATION_MESSAGE_MAXLENGTH_PATIENT_INITIALS', patientInitials_maxLength.toString()],
		[`${Validators.pattern.name}`]: ['VALIDATION_MESSAGE_SPECIALCHARS_PATIENT_INITIALS', SPECIAL_CHARS_TEXT]
	},
	planGuid: null,
	planId: {
		[`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_PLANID'],
		[`${Validators.maxLength.name.toLowerCase()}`]: ['VALIDATION_MESSAGE_MAXLENGTH_PLANID', planId_maxLength.toString()],
		[`${Validators.pattern.name}`]: ['VALIDATION_MESSAGE_SPECIALCHARS_PLANID', SPECIAL_CHARS_TEXT],
		[`${planId_notUnique}`]: ['VALIDATION_MESSAGE_UNIQUE_PLANID']
	},
	planNotes: {
		[`${Validators.maxLength.name.toLowerCase()}`]: ['VALIDATION_MESSAGE_MAXLENGTH_PLAN_NOTES', planNotes_maxLength.toString()],
		[`${Validators.pattern.name}`]: ['VALIDATION_MESSAGE_SPECIALCHARS_PLAN_NOTES', SPECIAL_CHARS_LITE_TEXT]
	},
	frameId: {
		[`${noFramesAvailable}`]: ['VALIDATION_MESSAGE_CLONE_NO_FRAMES']
	},
	device: {
		[`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_DEVICE'],
		[`${unsupportedModel}`]: ['VALIDATION_MESSAGE_MIGRATE_UNSUPPORTED_MODEL']
	}
}

export interface IReceivedCloneControl {
	existingPatient: FormControl<SearchItems | null>;
	patientId: FormControl<string | null>;
	patientInitials: FormControl<string | null>;
	planGuid: FormControl<string | null>;
	planId: FormControl<string | null>;
	planNotes: FormControl<string | null>;
	frameId: FormControl<FrameIDTypeEnum | null>;
	device: FormControl<DeviceEnum | null>;
}

export interface ReceivedCloneForm {
	existingPatient: SearchItems;
	patientId: string;
	patientInitials: string;
	planGuid: string;
	planId: string;
	planNotes: string;
	frameId: FrameIDTypeEnum | null;
	device: DeviceEnum | null;
}
